<script>
    import Chart from 'chart.js/auto';
    import { onMount } from 'svelte';
    import { theme } from '../stores.js';

    const light_background_color = 'rgb(255, 255, 255)';
    const light_grid_color = 'rgba(0, 0, 0, 0.05)';
    const light_legend_color = 'rgb(80, 85, 90)';
    const light_label_color = 'rgb(130, 135, 140)';
    const light_shadow_color = 'rgba(158, 205, 239, 0.54)';

    const dark_background_color = 'rgb(50, 55, 60)';
    const dark_grid_color = 'rgba(255, 255, 255, 0.05)';
    const dark_legend_color = 'rgb(210, 215, 220)';
    const dark_label_color = 'rgb(110, 115, 120)';
    const dark_shadow_color = 'rgba(28, 95, 145, 0.5)';    // 24, 75, 112

    let background_color = light_background_color;
    let grid_color = light_grid_color;
    let legend_color = light_legend_color;
    let label_color = light_label_color;
    let shadow_color = light_shadow_color;

    let ITNRosCanvas;
    let ITNStakeCanvas;
    let ITNBlocksCanvas;
    let ITNPerfCanvas;

    let ITNRosChart;
    let ITNStakeChart;
    let ITNBlockChart;
    let ITNPerfChart;

    const labels = ['Ep.13', 'Ep.14', 'Ep.15', 'Ep.16', 'Ep.17', 'Ep.18', 'Ep.19', 'Ep.20', 'Ep.21', 'Ep.22', 'Ep.23', 'Ep.24', 'Ep.25',
                        'Ep.26', 'Ep.27', 'Ep.28', 'Ep.29', 'Ep.30', 'Ep.31', 'Ep.32', 'Ep.33', 'Ep.34', 'Ep.35', 'Ep.36', 'Ep.37', 'Ep.38', 'Ep.39',
                        'Ep.40', 'Ep.41', 'Ep.42', 'Ep.43', 'Ep.44', 'Ep.45', 'Ep.46', 'Ep.47', 'Ep.48', 'Ep.49', 'Ep.50', 'Ep.51', 'Ep.52', 'Ep.53',
                        'Ep.54', 'Ep.55', 'Ep.56', 'Ep.57', 'Ep.58', 'Ep.59', 'Ep.60', 'Ep.61', 'Ep.62', 'Ep.63', 'Ep.64', 'Ep.65', 'Ep.66', 'Ep.67',
                        'Ep.68', 'Ep.69', 'Ep.70', 'Ep.71', 'Ep.72', 'Ep.73', 'Ep.74', 'Ep.75', 'Ep.76', 'Ep.77', 'Ep.78', 'Ep.79', 'Ep.80', 'Ep.81',
                        'Ep.82', 'Ep.83', 'Ep.84', 'Ep.85', 'Ep.86', 'Ep.87', 'Ep.88', 'Ep.89', 'Ep.90', 'Ep.91', 'Ep.92', 'Ep.93', 'Ep.94', 'Ep.95',
                        'Ep.96', 'Ep.97', 'Ep.98', 'Ep.99', 'Ep.100', 'Ep.101', 'Ep.102', 'Ep.103', 'Ep.104', 'Ep.105', 'Ep.106', 'Ep.107', 'Ep.108', 'Ep.109',
                        'Ep.110', 'Ep.111', 'Ep.112', 'Ep.113', 'Ep.114', 'Ep.115', 'Ep.116', 'Ep.117', 'Ep.118', 'Ep.119', 'Ep.120', 'Ep.121', 'Ep.122', 'Ep.123',
                        'Ep.124', 'Ep.125', 'Ep.126', 'Ep.127', 'Ep.128', 'Ep.129', 'Ep.130', 'Ep.131', 'Ep.132', 'Ep.133', 'Ep.134', 'Ep.135', 'Ep.136', 'Ep.137',
                        'Ep.138', 'Ep.139', 'Ep.140', 'Ep.141', 'Ep.142', 'Ep.143', 'Ep.144', 'Ep.145', 'Ep.146', 'Ep.147', 'Ep.148', 'Ep.149', 'Ep.150', 'Ep.151',
                        'Ep.152', 'Ep.153', 'Ep.154', 'Ep.155', 'Ep.156', 'Ep.157', 'Ep.158', 'Ep.159', 'Ep.160', 'Ep.161', 'Ep.162', 'Ep.163', 'Ep.164', 'Ep.165',
                        'Ep.166', 'Ep.167', 'Ep.168', 'Ep.169', 'Ep.170', 'Ep.171', 'Ep.172', 'Ep.173', 'Ep.174', 'Ep.175', 'Ep.176', 'Ep.177', 'Ep.178', 'Ep.179',
                        'Ep.180', 'Ep.181', 'Ep.182', 'Ep.183', 'Ep.184', 'Ep.185', 'Ep.186', 'Ep.187', 'Ep.188', 'Ep.189'];

    function initRos()
    {
        const ctx = ITNRosCanvas.getContext('2d');
        ITNRosChart = new Chart(ctx, {
                type: 'line',
                data: {
                labels: labels,
                datasets: [ {
                    data: [8.6, 10.6, 11.2,12.6,12.7,12.7,11.6,15.1,15.1,15.0,14.3,13.4,13.4,13.4,14.4,14.0,13.8,12.7,12.6,12.4,12.6,12.6,12.7,12.6,11.7,12.7,12.7,12.7,
                           11.4,12.6,12.6,12.6,12.6,12.7,11.6,11.3,10.2,9.3,10.3,11.8,8.6,14.6,13.4,10.6,16.6,16.0,11.1,12.7,12.4,4.7,9.5,9.9,14.5,11.8,9.0,14.8,10.3,
                           14.7,7.5,16,13.8,7.7,6.9,13.3,8.1,13.6,5.4,6.9,4.1,6.2,11.1,9.6,9.1,5.4,11.3,9.1,11,7.7,9.1,11.4,6.7,5.8,14.7,13.5,6.1,11.7,13.6,10.4,15.6,
                           15.2,8.0,13,14.8,10,13,15,8.7,11.5,14.8,11.1,10.6,10.0,9.3,13.8,8.6,13.3,9.8,14.2,15.5,8.9,13.7,11,15.7,13.1,8.8,14.3,11.2,10.9,9.2,13.0,11.0,
                           11.3,9.6,9.3,11.7,12.4,7.1,9.9,6.8,11.8,11.9,12.2,11.5,13,11.7,11.5,7.5,14.8,11.0,8.2,11.3,14.7,9.9,10.2,10.2,9.6,9.1,6.7,11.9,8,7.7,8,5.7,10.8,
                           11.5,11.3,6.1,12.4,8.6,10.4,10.5,9.1,7.7,14.7,8.7,10.9,8.1,8.0,8.4,11.5,14.4,11.0,13.5,8.6,8.9,11.4],
                    label: " Annualized Return On Stake",
                    borderColor: "#3e95cd",
                    // backgroundColor: "#ffffff",
                    fill: false,
                    pointRadius: 2,
                    lineTension: 0
                  },{
                    data: [9.5,8.9,8.4,9.1,9.7,10.2,10.6,11.3,11.9,12.5,13.09,13.37,13.59,13.67,13.84,13.97,14.19,13.95,13.7,13.44,13.27,13.19,13.12,13.04,12.77,12.64,12.53,12.53,
                           12.45,12.35,12.35,12.35,12.34,12.34,12.44,12.33,12.19,11.94,11.69,11.58,11.18,11.38,11.46,11.26,11.65,12.09,12.07,12.32,12.63,12.07,12.16,11.7,11.8,11.9,11.2,
                           11,11,11.2,10.7,11.8,12.2,12,11.2,11.4,11.3,11.2,10.7,9.9,9.6,8.6,8.3,8.5,8.7,8,8.3,7.8,8.4,8.5,9.0,9.5,9.0,8.7,9.2,10,9.5,9.8,10,10.3,11,11.3,11.5,12.2,12.2,
                           11.8,12.5,12.9,12.4,12.5,12.4,12,12.3,12,11.4,11.8,11.3,11.2,11.3,11.6,11.6,11.4,11.7,11.8,12.5,12.4,12.4,12.5,12.6,12.3,11.7,12.1,11.8,11.9,11.2,10.9,11.2,11,
                           10.6,10.5,10.2,10.1,10.2,10.3,10.5,10.8,10.8,10.7,10.8,11.3,11.7,11.3,11.3,11.5,11.4,11.1,10.9,10.7,10.9,10.1,10.2,10.2,9.8,9.1,8.7,8.8,8.9,9.1,8.8,9.3,9.0,9.3,
                           9.5,9.6,9.8,10.2,10,9.9,10.1,9.7,9.7,9.8,10.2,10.3,10.9,10.3,10.3,10.4],
                    label: " 10 days moving average",
                    borderColor: "#d436ed",
                    // backgroundColor: "#ffffff",
                    borderDash: [8,8],
                    pointRadius: 0,
                    fill: false,
                    lineTension: 0
                    }]
                },
                options: {
                    responsive: true,
                    interaction: { mode: 'index', intersect: false, },
                    stacked: false,
                    plugins: {
                      title: { display: true, text: ["ITN Return Of Investment"] },
                      legend: { display: true, labels: { boxHeight: 0, boxWidth: 24 } },
                      tooltip: {
                        callbacks: {
                          label: function(context) {return context.dataset.label + ": " + context.parsed.y + " %"; }
                        }
                      },
                    },
                    scales: {
                        xAxes: {},
                        yAxes: {
                            type: 'linear',
                            min: 0,
                            max: 18,
                            ticks: {
                                callback: function(value, index, values) { return  value + ' %'; }
                            }
                        }
                    }
                },
            });
    }

    function initStake() 
    {
        const ctx = ITNStakeCanvas.getContext('2d');
        ITNStakeChart = new Chart(ctx, {
                type: 'line',
                data: {
                labels: labels,
                datasets: [ {
                    data: [117.0, 118.1, 114.3,  103.8, 103.6, 103.6, 88.7, 87.6, 87.7, 88.5, 92.6, 98.2, 98.0, 98.2, 92.0, 94.4, 95.4, 103.3, 103.8, 105.5,
                           103.7, 103.9, 103.4, 103.7, 103.1, 103.3, 103.4, 103.1, 103.5, 103.8, 103.8, 103.9, 103.7, 104.0, 103.0, 112.9, 115.2, 82.3,
                           82.3, 82.3, 75.7, 75.5, 74.7, 74.5, 75.6, 75.4, 75.4, 77.0, 79.3, 73.6, 80.7, 79.0, 78.6, 75.1, 76.0, 76.0, 69.5, 69.4, 69.5, 60.2,
                           60.4, 59.2, 61.6, 61.1, 58.2, 50.8, 51.2, 50.9, 50.9, 49.7, 49.7, 48.5, 47.8, 47.3, 47.3, 47.1, 57.6, 57.6, 57.4, 57.0, 57.0, 57.1,
                           57.1, 57.1, 57.0, 57.0, 57.2, 46.8, 46.7, 48.4, 48.4, 48.8, 48.8, 48.9, 48.9, 48.6, 48.4, 48.5, 51.2, 51.2, 55.7, 53.3, 53.3, 57.9,
                           53.3, 50.8, 51.1, 51.1, 51.1, 51.1, 51.3, 51.4, 51.6, 51.7, 55.2, 55.5, 60.7, 61.1, 63.5, 63.7, 64.9, 75.0, 75.8, 75.9, 80.3, 79.1,
                           71.2, 70.6, 69.2, 68.0, 67.7, 66.4, 66.5, 66.5, 65.2, 65.2, 65.2, 65.3, 65.3, 65.3, 65.0, 65.0, 65.1, 65.0, 65.2, 65.2, 65.3, 65.3,
                           65.2, 65.3, 64.9, 64.8, 64.7, 64.7, 64.3, 61.8, 61.9, 62.6, 62.5, 59.9, 59.9, 60.3, 60.3, 60.3, 64.4, 64.4, 64.4, 64.4, 64.5, 64.7,
                           64.7, 64.7, 64.7, 65.1, 65.1],
                    label: "Stake",
                    borderColor: "#3e95cd",
                    // backgroundColor: "#ffffff",
                    fill: false,
                    pointRadius: 2,
                    lineTension: 0
                    }]
                },
                options: {
                  responsive: true,
                  interaction: { mode: 'index', intersect: false, },
                  stacked: false,
                    plugins: {
                      title: { display: true, text: 'ITN Stake [Ada]' },
                      legend: { display: false },
                      tooltip: {
                        callbacks: {
                          label: function(context) {return context.dataset.label + ": " + context.parsed.y + "M Ada"; }
                        }
                      },
                    },
                    scales: {
                        xAxes: {},
                        yAxes: {
                            display: true,
                            min: 0,
                            max: 120,
                            ticks: {
                                callback: function(value, index, values) { return  value + 'M'; }
                            }
                        }
                    }
                }
            });
    }

    function initBlocks() 
    {
        const ctx = ITNBlocksCanvas.getContext('2d');
        ITNBlockChart = new Chart(ctx, {
                type: 'bar',
                data: {
                labels: labels,
                datasets: [
                        {
                          label: "Signed blocks",
                          backgroundColor: "#3e95cd",
                          data: [28,33,55,43,57,40,24,42,38,42,35,39,32,37,37,36,32,51,29,45,47,47,33,34,30,31,51,36,29,28,36,36,36,43,56,37,39,23,20,21,
                                 17,26,27,22,35,35,24,29,29,10,22,23,32,26,20,31,19,27,15,26,22,13,12,23,14,19,8,10,6,9,15,13,12,7,14,12,17,12,14,18,11,10,
                                 24,22,10,19,22,14,21,21,12,19,22,15,19,22,13,17,23,18,18,16,15,24,14,20,16,23,24,14,22,18,25,21,15,24,21,21,18,26,23,26,23,23,
                                 30,30,16,22,15,25,26,26,24,27,24,23,16,30,23,17,23,29,20,21,21,20,19,14,24,17,16,17,12,21,23,22,12,24,17,20,20,17,15,27,18,22,
                                 16,17,17,23,29,23,28,18,18,23,19]
                        }, {
                          label: "Missed blocks",
                          backgroundColor: "rgba(158, 205, 239, 0.54)",
                          data: [31,21,3,5,3,8,3,1,6,4,8,8,15,12,11,9,6,9,13,13,11,5,12,8,8,7,8,6,7,8,13,4,10,3,4,13,11,3,6,9,7,5,11,11,0,1,1,2,1,12,4,2,1,0,5,
                                4,4,5,6,5,2,6,5,8,6,4,10,7,2,8,5,7,5,9,3,3,2,6,7,1,0,4,1,2,3,1,2,1,0,1,1,0,5,1,0,1,0,0,2,0,0,3,0,1,3,3,0,0,0,0,3,2,0,1,0,3,3,1,2,2,
                                0,3,2,4,2,1,2,1,0,1,1,0,1,1,1,1,0,1,0,1,1,1,1,2,1,1,0,0,2,1,1,2,2,1,2,1,1,0,0,0,1,1,0,1,0,1,1,1,0,2,0,1,0,1,0,0,1]
                        }
                    ]
                },
                options: {
                  responsive: true,
                  interaction: { mode: 'index', intersect: false, },
                  stacked: true,
                    plugins: {
                      title: { display: true, text: 'ITN Pool Performance [# blocks]' },
                      legend: { display: false },
                    },
                    scales: {
                        xAxes: {
                            stacked: true,
                        },
                        yAxes: {
                          min: 0,
                          max: 60,
                          stacked: true
                        }
                    }
                }
            });
    }

    function initPerf() 
    {
        const ctx = ITNPerfCanvas.getContext('2d');
        ITNPerfChart = new Chart(ctx, {
                type: 'line',
                data: {
                labels: labels,
                datasets: [{
                    data: [47.4, 61.1, 94.8, 89.6, 95.0, 83.3, 88.9, 97.7, 86.4, 91.4, 81.4, 83.0, 68.1,
                           75.5, 77.1, 80.0, 84.2, 85.0, 69.0, 77.6, 81.0, 90.4, 73.3, 81.0, 79.0, 81.6, 86.4, 85.7, 80.6, 77.8, 73.5,
                           90.0, 78.3, 93.0, 93.3, 74.0, 78.0, 88.5, 76.9, 70.0, 70.8, 83.9, 71.1, 66.7,  100, 97.2, 96.0, 93.5, 96.7,
                           45.5, 84.6, 92.0, 97.0,  100, 80.0, 88.6, 82.6, 84.4, 71.4, 83.9, 91.7, 68.4, 70.6, 74.2, 70.0, 82.6, 44.4,
                           58.8, 75.0, 52.9, 75.0, 65.0, 70.6, 43.8, 82.3, 80.0, 89.5, 66.7, 66.7, 94.7,  100, 71.4, 96.0, 91.7, 76.9,
                           95.0, 91.7, 93.3,  100, 95.5, 92.3,  100, 81.5, 93.8, 100, 95.7,  100,  100, 92.0,  100,  100, 84.2,  100,
                           96.0, 82.4, 87.0,  100,  100,  100,  100, 88.0, 90.0, 100, 95.5,  100, 88.9, 87.5, 95.5, 90.0, 92.9,  100,
                           89.7, 92.0, 85.2, 93.8, 96.8, 88.9, 95.7,  100, 96.2, 96.3,  100, 96.0, 96.4, 96.0, 95.8,  100, 96.8,  100,
                           94.4, 95.8, 96.7, 95.2, 91.3, 95.5, 95.2,  100,  100, 92.3, 94.4, 94.1, 89.5, 85.7, 95.5, 92.0, 95.7, 92.3,
                            100,  100,  100, 95.2, 94.4,  100, 96.4,  100, 95.7, 94.1, 94.4,  100, 92.0,  100, 95.8,  100, 94.7,  100,
                            100, 95.0],
                    label: "Performance",
                    borderColor: "#3e95cd",
                    // backgroundColor: "#ffffff",
                    pointRadius: 2,
                    //fill: false,
                    //lineTension: 0
                  }]
                },
                options: {
                    responsive: true,
                    interaction: { mode: 'index', intersect: false, },
                    stacked: false,
                    plugins: {
                      title: { display: true, text: 'ITN Pool Performance [% blocks]' },
                      legend: { display: false },
                      tooltip: {
                        callbacks: {
                          label: function(context) {return context.dataset.label + ": " + context.parsed.y + "%"; }
                        }
                      },
                    },
                    scales: {
                        xAxes: {},
                        yAxes: {
                            display: true,
                            min: 0,
                            max: 100,
                            ticks: {
                                callback: function(value, index, values) { return  value + ' %'; }
                            }
                        }
                    }
                }
            });
    }

    $: setChartTheme($theme)

    function setChartTheme(theme) 
    {
        if (theme == 'light') {
            background_color = light_background_color;
            grid_color = light_grid_color;
            legend_color = light_legend_color;
            label_color = light_label_color;
            shadow_color = light_shadow_color;
        }
        else {
            background_color = dark_background_color;
            grid_color = dark_grid_color;
            legend_color = dark_legend_color;
            label_color = dark_label_color;
            shadow_color = dark_shadow_color;
        }

        Chart.defaults.backgroundColor = background_color;
        Chart.defaults.color = legend_color;
        //Chart.defaults.scale.grid.borderColor = grid_color;
        //Chart.defaults.scale.grid.color = grid_color;

        if(ITNRosChart) {
          ITNRosChart.options.scales.yAxes.grid.color = grid_color;
          ITNRosChart.options.scales.yAxes.grid.borderColor = grid_color;
          ITNRosChart.options.scales.xAxes.grid.color = grid_color;
          ITNRosChart.options.scales.xAxes.grid.borderColor = grid_color;
          ITNRosChart.update();
        }

        if(ITNStakeChart) {
          ITNStakeChart.options.scales.yAxes.grid.color = grid_color;
          ITNStakeChart.options.scales.yAxes.grid.borderColor = grid_color;
          ITNStakeChart.options.scales.xAxes.grid.color = grid_color;
          ITNStakeChart.options.scales.xAxes.grid.borderColor = grid_color;
          ITNStakeChart.update();
        }

        if(ITNBlockChart) {
          ITNBlockChart.options.scales.yAxes.grid.color = grid_color;
          ITNBlockChart.options.scales.yAxes.grid.borderColor = grid_color;
          ITNBlockChart.options.scales.xAxes.grid.color = grid_color;
          ITNBlockChart.options.scales.xAxes.grid.borderColor = grid_color;
          ITNBlockChart.data.datasets[1].backgroundColor = shadow_color;
          ITNBlockChart.update();
        }

        if(ITNPerfChart) {
          ITNPerfChart.options.scales.yAxes.grid.color = grid_color;
          ITNPerfChart.options.scales.yAxes.grid.borderColor = grid_color;
          ITNPerfChart.options.scales.xAxes.grid.color = grid_color;
          ITNPerfChart.options.scales.xAxes.grid.borderColor = grid_color;
          ITNPerfChart.update();
        }
    }

    let w;
    let chartSize;
    $: setChartStyle(w);

    function setChartStyle(width) 
    {
        if (width == undefined) return;

        const desiredSize = (width < 480) ? 'small' : 'large';

        if (chartSize != desiredSize)
        {
            if (desiredSize == 'small') {
                ITNRosChart.data.datasets[0].label = ' Return On Stake';
                ITNRosChart.data.datasets[0].pointRadius = 0;
                ITNRosChart.data.datasets[0].borderWidth = 2;
                ITNRosChart.data.datasets[1].borderWidth = 2;
                ITNRosChart.data.datasets[1].borderDash = [];

                ITNStakeChart.data.datasets[0].pointRadius = 0;
                ITNStakeChart.data.datasets[0].borderWidth = 2;

                ITNPerfChart.data.datasets[0].pointRadius = 0;
                ITNPerfChart.data.datasets[0].borderWidth = 2;
            }
            if (desiredSize == 'large') {
                ITNRosChart.data.datasets[0].label = ' Annualized Return On Stake';
                ITNRosChart.data.datasets[0].pointRadius = 3;
                ITNRosChart.data.datasets[0].borderWidth = 3;
                ITNRosChart.data.datasets[0].pointBorderWidth = 1;
                ITNRosChart.data.datasets[1].borderWidth = 3;
                ITNRosChart.data.datasets[1].pointBorderWidth = 1;
                ITNRosChart.data.datasets[1].borderDash = [8,8];

                ITNStakeChart.data.datasets[0].pointRadius = 3;
                ITNStakeChart.data.datasets[0].borderWidth = 3;
                ITNStakeChart.data.datasets[0].pointBorderWidth = 1;

                ITNPerfChart.data.datasets[0].pointRadius = 3;
                ITNPerfChart.data.datasets[0].borderWidth = 3;
                ITNPerfChart.data.datasets[0].pointBorderWidth = 1;
            }
            chartSize = desiredSize;

            ITNRosChart.update();
            ITNStakeChart.update();
            ITNPerfChart.update();
        }
    }

    onMount(async () => {
        initRos();
        initStake();
        initBlocks();
        initPerf();

        setChartTheme($theme);
    });
</script>


<div class="container" bind:clientWidth={w}>
    <canvas bind:this={ITNRosCanvas} ></canvas>
    <canvas bind:this={ITNStakeCanvas} ></canvas>
    <canvas bind:this={ITNBlocksCanvas} ></canvas>
    <canvas bind:this={ITNPerfCanvas} ></canvas>
</div>


<style>

    .container {
        padding-top: 2em;
        padding-bottom: 2em;
        display: flex;
        flex-direction: column;
        gap: 2em;
    }

    canvas {
        width: 100%;
        max-height: 400px;
    }

</style>